import React from 'react';
import Header from './Header.js';
import Services from './Services';
import AboutSummary from './AboutSummary';
import Education from './Education';
import Footer from './Footer';
import About from './About';
//import Contact from './Contact';
import { HashRouter, Route, Switch } from "react-router-dom";
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fab);
library.add(fas);

const Default = () => {
    return (
        <>
        <AboutSummary></AboutSummary>
        <Services></Services>
        <Education></Education>
        </>
    )
}

const App = () => {
    return(
        <HashRouter>
            <div className="App">           
                <Header></Header>
                    <Switch>
                        <Route path="/" exact component={ Default }></Route>
                        <Route path="/about" component={ About }></Route>
                        {/*<Route path="/contact" component={Contact}></Route>*/}
                    </Switch>
                <Footer></Footer>
            </div>        
        </HashRouter>
    )
}

export default App;